export default "/images/si-img1.jpg?5d30e3f4cf09febf32101f435c0f7d89";